// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5856": "03084237","8990": "7d69c8cd","9066": "c1fdd670","9988": "01570931",}[chunkId] + ".css"
}